export enum ConservationType {
  Monitoring = 'M',
  Preservation = 'P',
  Regeneration = 'R',
  Damping = 'A',
}

export enum ConservationTypeInverted {
  'M' = 'Monitoração',
  'P' = 'Preservação',
  'R' = 'Regeneração',
  'A' = 'Amortecimento',
}
